export { default, getServerSideProps } from "pages/[lang]/bumble-better";
